module.exports = __webpack_public_path__ + "static/media/litlePokedex.d532a30b.png";